export const RATE_FACILITY_OVERVIEW_PATH = "/overview/rate-facilities";

export const canAccessRateFacilityOverview = (userData) => {
  const roleLevel = Number(userData?.role?.level);
  const propertyId = Number(userData?.property?.id);

  return roleLevel === 1 || propertyId === 3;
};
